export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE_SIMPLE_CERTIFICATES = 10;
